import moment from 'moment';

const integerDate = (format) => {
    return parseInt(moment().format(format), 10);
};
function reverse(string) {
    return [...string].reverse().join('');
}
const cdnHash = () => {
    var _a;
    const day = integerDate('D');
    const month = integerDate('M');
    const year = integerDate('YYYY');
    const { cdnKey } = JSON.parse((_a = localStorage.getItem('settings')) !== null && _a !== void 0 ? _a : '0');
    let dateMultiply = Math.pow((day * month * year), 2);
    if (cdnKey > 0) {
        dateMultiply *= cdnKey;
    }
    const dateMultiplyFormatted = String(dateMultiply);
    const replaceZeros = `${dateMultiplyFormatted.replaceAll('0', '0x')}${reverse(dateMultiplyFormatted).replaceAll('0', 'y0')}`;
    const replaceDigits = replaceZeros
        .replaceAll('1', 'a')
        .replaceAll('2', 'b')
        .replaceAll('3', 'c')
        .replaceAll('4', 'd')
        .replaceAll('5', 'e')
        .replaceAll('6', 'f');
    return replaceDigits;
};

export { cdnHash };
